import React, { FC } from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import { BackDrawerButton, TextField } from 'components/generic';
import { useCodeInputStep } from 'hooks/auth';

interface CodeInputStepProps {
  prevStep: () => void;
  onClose: () => void;
}

const CodeInputStep: FC<CodeInputStepProps> = ({ prevStep, onClose }) => {
  const {
    t,
    control,
    verifyIsLoading,
    isTimer,
    hint,
    handleGetCode,
    loginValue,
    handleLogIn,
    trySendAgain,
    sendAgain,
    mask,
  } = useCodeInputStep(onClose);

  return (
    <Box sx={{ padding: '100px 20px 20px 20px' }}>
      <Box
        sx={{ position: 'fixed', top: '24px', left: '20px', zIndex: '100' }}
        onClick={prevStep}
      >
        <BackDrawerButton direction="down" />
      </Box>
      <Box>
        <Typography sx={{ marginBottom: '11px' }} variant="h4">
          {t('confirmation_code')}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: '17px',
            lineHeight: '21px',
          }}
        >
          {hint} {loginValue}
        </Typography>
      </Box>
      <Box sx={{ marginBottom: '50px' }}>
        <TextField
          control={control}
          name="code"
          label={t('login.code')}
          mask={mask}
          maskPlaceholder={null}
          required
          endIcon={
            verifyIsLoading ? (
              <CircularProgress size={25} color="primary" />
            ) : (
              <></>
            )
          }
        />
      </Box>
      <Box sx={{ marginBottom: '25px' }}>
        {isTimer ? (
          <Typography
            sx={{
              fontSize: '16px',
              lineHeight: '18px',
              color: 'secondary.main',
            }}
          >
            {trySendAgain}
          </Typography>
        ) : (
          <Typography
            sx={{
              fontSize: '16px',
              lineHeight: '18px',
              color: 'secondary.main',
              alignSelf: 'flex-start',
            }}
            onClick={handleGetCode}
          >
            {sendAgain}
          </Typography>
        )}
      </Box>

      <Button
        sx={{
          padding: '15px 0',
          textTransform: 'inherit',
          fontSize: '18px',
          lineHeight: '21px',
          borderRadius: '6px',
          boxShadow: 'none',
          fontWeight: '300',
          color: 'primary.contrastText',
        }}
        variant="contained"
        color="primary"
        fullWidth
        type="submit"
        onClick={handleLogIn}
      >
        {t('continue')}
      </Button>
    </Box>
  );
};

export default CodeInputStep;
